<template>
	<div id="tabs-container">

		<ul class="nav nav-tabs" role="tablist">
			<li role="presentation" class="active">
				<a href="#query-panel" role="tab" data-toggle="tab" id="query-tab">
					Query
				</a>
			</li>
			<li role="presentation">
				<a href="#graph-panel" role="tab" data-toggle="tab" id="graph-tab">
					Graph
				</a>
			</li>
		</ul>

		<div class="tab-content">
			<div role="tabpanel" class="tab-pane active" id="query-panel">
				<basket></basket>
			</div>
			<div role="tabpanel" class="tab-pane" id="graph-panel">
				<ts-chart v-if="loaded"></ts-chart>
				<spinner v-if="pending"></spinner>
			</div>
		</div>
	</div>
</template>


<script type="text/javascript">

	import Basket from './Basket.vue'
	import TSChart from './TSChart.vue'
	import Spinner from 'vue-spinner/src/RingLoader.vue'

	export default {

		components: {
			'basket': Basket,
			'ts-chart': TSChart,
			'spinner': Spinner
		},
		computed: {
			loaded() {
				return (this.$store.state.basket.loaded && !this.$store.state.basket.pending)
			},
			pending() {
				return this.$store.state.basket.pending
			}
		},
		watch: {
			loaded(value){
				if (value) {
					$('#graph-tab').tab('show')
				}
			}
		}
	}


</script>
